<template>
  <a-modal
      :visible="visible"
      :title="disTitle"
      :okText="$t('ok')"
      :cancel-text="$t('cancel')"
      :destroyOnClose="true"
      :width="600"
      @cancel="
      () => {
        this.visible = false
        $emit('cancel')
      }
    "
      @ok="() => save()"
  >
    <a-form-model
        :model="record"
        ref="editConnectFeatureForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
    >
      <a-form-model-item :label="$t('page_ops_machine_connect_virtualIp')" prop="virtualIp">
        <a-input v-model="record.virtualIp" :placeholder="$t('page_ops_machine_connect_virtualIp')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_connect_virtualPort')" prop="virtualPort">
        <a-input v-model="record.virtualPort" :placeholder="$t('page_ops_machine_connect_virtualPort')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_connect_machineIp')" prop="ip">
        <a-input v-model="record.ip" :placeholder="$t('page_ops_machine_connect_machineIp')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_connect_machinePort')" prop="port">
        <a-input v-model="record.port" :placeholder="$t('page_ops_machine_connect_machinePort')" />
      </a-form-model-item>

      <a-form-model-item
          :label="$t('page_ops_machine_connect_transportProtocol')"
          prop="protocol"
      >
        <a-select
            show-search
            optionFilterProp="children"
            v-model="record.protocol"
            :placeholder="$t('page_ops_machine_connect_transportProtocol')"
        >
          <a-select-option v-for="item in protocolList" :key="item" :value="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
          :label="$t('page_ops_machine_connect_applicationProtocol')"
          prop="appProtocol"
      >
        <a-select
            show-search
            optionFilterProp="children"
            v-model="record.appProtocol"
            :placeholder="$t('page_ops_machine_connect_applicationProtocol')"
        >
          <a-select-option v-for="item in appProtocolList" :key="item" :value="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-model-item>

    </a-form-model>
  </a-modal>
</template>

<script>

import {
  DeviceExtranetConfigDTO,
  ExtranetServiceProxy, ExtranetSettingServiceProxy
} from "../../../../service-proxies/app-v2/extranet.service-proxies";

const extranetSrvProxy = new ExtranetServiceProxy()
const extranetSettingProxy = new ExtranetSettingServiceProxy();

export default {
  components: {
  },
  props: {},
  data() {
    return {
      visible: false,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        virtualIp: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],
        virtualPort: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],
        ip: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],
        port: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],
        protocol: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ]
        ,
        appProtocol: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ]
      },
      protocolList: [],
      appProtocolList: [],
      workStationId: undefined,
      record: {

      }
    }
  },
  computed: {
    disTitle() {
      return this.record.id
          ? this.$t('page_ops_machine_connect_edit')
          : this.$t('page_ops_machine_connect_new')
    }
  },
  methods: {
    saveFile(list) {
      this.fileList = list
    },
    open(workStationId, record) {
      // 获取默认配置只有在打开
      this.workStationId = workStationId;
      if(record){
        this.record={...record}
      }else{
        this.record={}
      }
      this.visible = true

      extranetSrvProxy.getSupportProtocols().then(res => {
        this.protocolList = res.protocolList
        this.appProtocolList = res.appProtocolList
        return extranetSettingProxy.getExtranetSetting()
      })
      .then(res=>{
        if(!this.record.virtualIp){
          this.record={
            virtualIp: res.virtualIp,
            virtualPort: res.virtualPort,
            ip: res.ip,
            port: res.port,
            protocol: 'TCP',
            appProtocol: 'Default',
          }
        }
      })
    },
    handleChange(e) {
      this.value = e.target.value
    },
    save() {
      this.$refs.editConnectFeatureForm.validate((valid) => {
        if (valid) {
          if(!this.record.id){
            this.add();
          }else{
            this.update();
          }
        } else {
          return false
        }
      })
    },
    add(){
      const dto = new DeviceExtranetConfigDTO()
      dto.init(this.record)
      dto.deviceId = this.workStationId;
      extranetSrvProxy.addDeviceExtranetConfig(dto)
          .then(res=>{
            const msg = this.$t('save_success').toString()
            this.$message.success(msg)
            this.visible = false
            this.$emit('save')
          });
    },
    update(){
      const dto = new DeviceExtranetConfigDTO()
      dto.init(this.record)
      dto.deviceId = this.workStationId;
      extranetSrvProxy.updateDeviceExtranetConfig(
          this.record.id,
          dto)
          .then(res=>{
            const msg = this.$t('save_success').toString()
            this.$message.success(msg)
            this.visible = false
            this.$emit('save')
          });
    }


  }
}
</script>

<style lang="less" scoped>

</style>
